import React, { useContext } from 'react'
import ProductFruitsContext from './ProductFruitsContext'

export default () => {
  const context = useContext(ProductFruitsContext)
  if (!context) {
    throw new Error('ProductFruitsContext cannot be used outside ProductFruitsContext.Provider')
  }
  return context
}